// import Swiper bundle with all modules installed
import React from 'react';
import Swiper from 'swiper/bundle';
// init Swiper:
jQuery(document).ready(function ()
{
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        // If we need pagination
        // pagination: {
        //     el: '.swiper-pagination',
        // },

        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
            type: 'custom',
            renderCustom: function (swiper, current, total)
            {
                return '<span class="swiper-pagination-current">' + current + '</span>' + '|' +'<span class="swiper-pagination-total">' + (total) +'</span>';

            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // // And if we need scrollbar
        // scrollbar: {
        //     el: '.swiper-scrollbar',
        // },
    });
})
